// extracted by mini-css-extract-plugin
export default {"blockIngredients":"burger-ingredients_blockIngredients__Oxxxy","burgerIngredients":"burger-ingredients_burgerIngredients__-kqq6"};